export const DICH_VU = "dich_vu"
const ROUTER = {
  DEFAULT: "/",
  SCAN_QR: "/scan-qr",
  MEMBER_INFO: "/thong-tin-hoi-vien",
  MEMBER_CARD: "member-card",
  SVG_VIEWER: "/svg-viewer",
  RECEIVER: "/receiver",
  HOME: "/",
  DANG_NHAP: "/",
  DANG_KY: "/dang-ky",
  DOI_MAT_KHAU: "/doi-mat-khau",
  //Mạng xã hội

  LOGIN_GOOGLE: "/dang-nhap-tu-mang-xa-hoi",

  //ANONYMOUS
  LICH_HOP_CUA_TOI: "/lich-hop-cua-toi",
  DANG_KY_LICH_HOP: "/dang-ky-lich-hop",
  DANG_KY_THONG_TIN_KHACH: "/dang-ky-thong-tin-khach",
  QUYEN_LOI_HOI_VIEN: "/quyen-loi-hoi-vien",
  DANH_SACH_HOI_VIEN: "/danh-sach-hoi-vien",
  DIEU_KIEN_VA_THU_TUC: "/dieu-kien-thu-tuc",
  DANH_SACH_HOI_NHOM: "/danh-sach-hoi-nhom",
  HOI_NHOM_CHI_TIET: id => `/hoi-nhom-chi-tiet/${id}`,
  DANG_KI_DOANH_NGHIEP: "/dang-ki-doanh-nghiep",
  LIEN_HE_HO_TRO: "/lien-he-ho-tro",
  DANG_KY_QUANG_CAO_KHACH: "/dang-ky-quang-cao",
  DANG_NHAP_LINK: "/login",

  // ADMIN
  TONG_QUAN: "/tong-quan",
  QUAN_LY_HOI_VIEN: "/quan-ly-hoi-vien",
  QUAN_LY_DON_VI: "/hoi-vien-dang-ky",
  DANH_SACH_HIEP_HOI: "/danh-sach-hiep-hoi",
  PHE_DUYET_HIEP_HOI: "/phe-duyet-hiep-hoi",
  DANH_SACH_QUYEN_LOI: "/danh-sach-quyen-loi",
  DANH_SACH_LOAI_HOI_VIEN: "/danh-sach-loai-hoi-vien",
  THONG_KE_HOI_VIEN: "/thong-ke-hoi-vien",
  QUAN_LY_LICH_HOP: "/quan-ly-lich-hop",
  QUAN_LY_PHONG_HOP: "/quan-ly-phong-hop",
  QUAN_LY_PHAN_QUYEN: "/phan-quyen",
  DANH_BA_NHAN_VIEN: "/danh-ba-nhan-vien",
  PHE_DUYET_THU_CHI: "/phe-duyet-thu-chi",
  DANH_SACH_THU_CHI: "/danh-sach-thu-chi",
  DANH_SACH_HOI_PHI: "/danh-sach-hoi-phi",
  QUAN_LY_THONG_BAO: "/quan-ly-thong-bao",
  DUYET_GIA_NHAP: "/duyet-gia-nhap",
  DUYET_ROI_HOI: "/duyet-roi-hoi",
  XU_LY_KHIEU_NAI: "/xu-ly-khieu-nai",
  XU_LY_YEU_CAU_HO_TRO: "/xu-ly-yeu-cau-ho-tro",
  DON_XIN_GIA_NHAP: "/don-xin-gia-nhap",
  DANH_SACH_DON_VI: "/danh-sach-don-vi",
  NHOM_DON_VI: "/nhom-don-vi",
  CHUC_VU: "/chuc-vu",
  PHE_DUYET_QUANG_CAO: "/phe-duyet-quang-cao",
  QUAN_LY_GOI_QUANG_CAO: "/quan-ly-goi-quang-cao",
  //User
  DICH_VU: DICH_VU,
  THONG_TIN_TAI_KHOAN: `/${DICH_VU}/thong-tin-ca-nhan`,
  DANH_SACH_YEU_CAU_HO_TRO: `/${DICH_VU}/danh-sach-yeu-cau-ho-tro`,
  NANG_CAP_GOI_HOI_VIEN: `/${DICH_VU}/nang-cap-goi-hoi-vien`,
  HOI_PHI: `/${DICH_VU}/hoi-phi`,

  PHI_CHUA_DONG: `/${DICH_VU}/phi-chua-dong`,
  LICH_SU_DONG_PHI: `/${DICH_VU}/lich-su-dong-phi`,

  DANH_SACH_HOI_THAM_GIA: `/${DICH_VU}/danh-sach-hoi-tham-gia`,
  DANG_KY_HIEP_HOI: `/${DICH_VU}/dang-ky-hiep-hoi`,
  QUANG_CAO: `/${DICH_VU}/quang-cao`,
  DANG_KY_QUANG_CAO: `/${DICH_VU}/dang-ky-quang-cao`,
  DE_XUAT_QUANG_CAO: `/${DICH_VU}/de-xuat-quang-cao`,
  DON_DANG_KY_QUANG_CAO: `/${DICH_VU}/don-dang-ky-quang-cao`,

  DANG_KI_CA_NHAN: "/dang-ki-ca-nhan",
  CHUNG_NHAN_HOI_VIEN: "/chung-nhan-hoi-vien",
}
export default ROUTER
